import React, { useState } from "react";
import { Container, Button, Badge, Card, Tabs, Tab } from "react-bootstrap";
import { FaHome, FaSignOutAlt, FaUsers, FaCog } from "react-icons/fa";
import AdminTeamManager from "./AdminTeamManager";
import AdminHomeManager from "./AdminHomeManager";
import ServicesAdmin from "./ServicesAdmin";
import { useNavigate } from "react-router-dom";
// const API_URL = "http://radheyelectical.atwebpages.com/api/api_handler.php";

const AdminDashboard = () => {
  const [activeKey, setActiveKey] = useState("home"); // Main Tab Control
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin/login");
  };

  return (
    <Container className="mt-5 pt-5 py-5">
      {/* --- HEADER SECTION --- */}
      <div className="d-flex justify-content-between align-items-center mt-5 mb-4 pb-3 border-bottom">
        <div className="d-flex align-items-center">
          <h2 className="mb-0 fw-bold text-dark">Admin Dashboard</h2>
          <Badge bg="primary" className="ms-3">
            {/* v2.0 */}
          </Badge>
        </div>
        <Button
          variant="outline-danger"
          className="d-flex align-items-center"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="me-2" /> Logout
        </Button>
      </div>

      {/* --- MAIN NAVIGATION TABS --- */}
      <Tabs
        id="admin-tabs"
        activeKey={activeKey}
        onSelect={(k) => setActiveKey(k)}
        className="mb-4 custom-tabs"
        justify
      >
        <Tab
          eventKey="home"
          title={
            <span>
              <FaHome className="me-2" />
              Home Page
            </span>
          }
        >
          <AdminHomeManager />
        </Tab>

        <Tab
          eventKey="team"
          title={
            <span>
              <FaUsers className="me-2" />
              About Us
            </span>
          }
        >
          <div className="mt-4">
            <AdminTeamManager />
          </div>
        </Tab>

        <Tab
          eventKey="Service Page"
          title={
            <span>
              <FaUsers className="me-2" />
              Service Page
            </span>
          }
        >
          <div className="mt-4">
            {" "}
            <ServicesAdmin />{" "}
          </div>
        </Tab>
        <Tab
          eventKey="Project Page"
          title={
            <span>
              <FaUsers className="me-2" />
              Project Page
            </span>
          }
        >
          <div className="mt-4">{/* <AdminTeamManager /> */}</div>
        </Tab>

        <Tab
          eventKey="Gallery Page"
          title={
            <span>
              <FaUsers className="me-2" />
              Gallery Page
            </span>
          }
        >
          <div className="mt-4">{/* <AdminTeamManager /> */}</div>
        </Tab>

        <Tab
          eventKey="Career Page"
          title={
            <span>
              <FaCog className="me-2" />
              Career Page
            </span>
          }
        >
          <Card className="mt-3 border-0 shadow-sm p-5 text-center">
            <h4>Site Settings</h4>
            <p className="text-muted">Configure global site variables here.</p>
            <Button variant="primary" disabled>
              Coming Soon
            </Button>
          </Card>
        </Tab>
        <Tab
          eventKey="Inquiry Page"
          title={
            <span>
              <FaUsers className="me-2" />
              Inquiry Page
            </span>
          }
        >
          <div className="mt-4">{/* <AdminTeamManager /> */}</div>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default AdminDashboard;
